module.exports = __webpack_public_path__ + "img/putdisk.d4ca1c48.png";